import appConfig from '../../../../config/appConfig';
import {ENABLE_PREFERENCE_CENTER} from '../../../../consts/tnc/aggregatedSettingTypes';
import marketConfigService from '../../../../services/marketConfigService';
import tncService from '../../../../services/tncService';

const usePreferenceCenterEnabled = () => {
    const isDeviceSettingAvailable = appConfig.getIsDeviceSettingAvailable();
    const isTNCEnabled = marketConfigService.isTNCEnabled();
    const isPreferenceCenterEnabled = tncService.isAggregatedSettingEnabled(ENABLE_PREFERENCE_CENTER);

    return isDeviceSettingAvailable && isTNCEnabled && isPreferenceCenterEnabled;
};

export default usePreferenceCenterEnabled;
